(function($) {
	
	$('#translatebutton').click(function(){
		 $('#translatebox').show();
		 $('#translatebody').show();
	 });
	 
	 $('#translatebuttonm').click(function(){
		 $('#translatebox').show();
		 $('#translatebody').show();
	 });
	 
	 $('#translateclose').click(function(){
		 //for leaving tab docked
		 //$('#translatebody').hide();
		 //$('#translatebox').css('height','auto');
		 
		 //for closing completely
		 $('#translatebox').hide();
	 });
	 
	 $('#translatesave').click(function(){
		 $('#translatebox').hide();
	 });
	
})( jQuery );